import { useEffect } from 'react'
import Parallax from 'parallax-js'

/**
 * Re-creates the old parallax.js effect on the right-hand banner
 * (previously loaded as <script src="js/plugins/parallax.js">).
 *
 * parallax-js auto-detects any child element with a `data-depth` attribute
 * inside the scene element you pass it — which is exactly how
 * PersonBanner.jsx's `.mil-banner-wrapper` / `.mil-flying-skills` divs are
 * already marked up, so no markup changes are needed.
 *
 * @param {React.RefObject<HTMLElement>} sceneRef - ref to the element with id="scene"
 */
export function useParallax(sceneRef) {
  useEffect(() => {
    if (!sceneRef.current) return

    const instance = new Parallax(sceneRef.current, {
      relativeInput: true,
    })

    return () => {
      instance.destroy()
    }
  }, [sceneRef])
}
